export enum ImageholderVariants {
  WITHLINK = 'OUTLINED',
  DEFAULT = 'DEFAULT',
}
